import React, { ChangeEvent, KeyboardEventHandler, useState, VoidFunctionComponent } from "react";

interface Props {
    id?: string;
    type?: "text" | "password" | "tel",
    field?: string,
    value?: string,
    callback: (value: string, field?: string) => void,
    label?: string,
    topMessage?: string,
    bottomMessage?: string | boolean,
    placeholder?: string,
    disabled?: boolean,
    readOnly?: boolean,
    error?: boolean,
    onSelect?: (value: string, field?: string) => void,
    name?: string;
    dataInputSource?: string;
    defaultValue?: string;
    onFocus?: () => void;
    autoComplete?: string;
}

export const TextField: VoidFunctionComponent<Props> = ({
    id,
    topMessage,
    type,
    bottomMessage,
    field,
    readOnly,
    error,
    disabled,
    placeholder,
    value,
    label,
    callback,
    onSelect = () => {},
    name,
    dataInputSource,
    defaultValue,
    onFocus,
    autoComplete="new-zipCode",
}) => {
    const [localType, setLocalType] = useState(type || 'text');

    return (
        <div className={`textField ${error ? 'error' : ''}`}>
            {label && <label className={"label"}>{label}</label>}
            {topMessage && <span className={"topMessage"}>{topMessage}</span>}
            <div className="input-wrapper">
                <input
                    id={id}
                    type={localType}
                    value={value}
                    disabled={disabled}
                    readOnly={readOnly}
                    placeholder={placeholder}
                    className={type}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => callback(e.target.value, field)}
                    pattern={type === 'tel' ? '(\\+|0)[0-9]{9,}' : undefined}
                    autoComplete={autoComplete}
                    onSelect={(e: ChangeEvent<HTMLInputElement>) => onSelect(e.target.value, field)}
                    name={name}
                    data-input_source={dataInputSource}
                    defaultValue={defaultValue}
                    onFocus={onFocus}
                />
                {type === 'password' &&
                    <button
                        onClick={() => setLocalType(p => p === 'password' ? 'text' : 'password')}
                    >
                        <img
                            src={localType === 'password' ? "/assets/images/responsive/icons/eyeEmpty.svg" : "/assets/images/responsive/icons/eyeOff.svg"} />
                    </button>
                }
            </div>
            {bottomMessage && <span className={"bottomMessage"}>{bottomMessage}</span>}
        </div>
    )
};